import React, { useEffect } from "react"
import styled from "styled-components"

const Title = styled.h1`
  margin-top: 50px;
  text-align: center;
  font-size: 50px;
  font-weight: 700;
  color: #fed9ae;

  line-height: 75px;
  font-family: "PlayfairDisplay-BoldItalic";
`

const Instagram = () => {
  useEffect(() => {
    {
      ;(function (d, s, id) {
        var js
        if (d.getElementById(id)) {
          return
        }
        js = d.createElement(s)
        js.id = id
        js.src = "https://embedsocial.com/cdn/ht.js"
        d.getElementsByTagName("head")[0].appendChild(js)
      })(document, "script", "EmbedSocialHashtagScript")
    }
  }, [])

  const renderSocial = () => {
    return (
      <div
        className="embedsocial-hashtag"
        data-ref="54f804328aaac132d413a9792a7ca7f66222e2db"
      >
        <a
          className="feed-powered-by-es feed-powered-by-es-slider"
          href="https://embedsocial.com/social-media-aggregator/"
          target="_blank"
          title="Widget by EmbedSocial"
        ></a>
      </div>
    )
  }

  return (
    <>
      <Title>
        Instagram
        <span style={{ color: "#f89e95" }}>.</span>
      </Title>
      {renderSocial()}
    </>
  )
}

export default Instagram
